<template>
  <b-card>
    <!-- Alert: No item found -->
    <!-- <b-alert variant="danger" :show="userData === undefined">
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link class="alert-link" :to="{ name: 'apps-users-list' }">
          User List
        </b-link>
        for other users.
      </div>
    </b-alert> -->

    <b-tabs pills>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">บัญชีผู้ใช้งาน</span>
        </template>
        <user-edit-tab-account :user-data="userModel" class="mt-2 pt-75" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import userStoreModule from "../userStoreModule";
import UserEditTabAccount from "./UserEditTabAccount.vue";
import useUsersList from "../members-list/useMembersList.js";
export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    UserEditTabAccount,
  },

  setup() {
    const { userModel } = useUsersList();

    const USER_APP_STORE_MODULE_NAME = "user";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });
    if (router.currentRoute.params.id) {
      store
        .dispatch("user/fetchUser", { id: router.currentRoute.params.id })
        .then((response) => {
          console.log("getById", response);
          // map BindingData
        })
        .catch((error) => {
          if (error.response.status === 404) {
            console.log("err", error);
          }
        });
    }
    return {
      userModel,
    };
  },
  methods: {},
};
</script>
